import Icon from '../components/Icon.vue'

Icon.register({"reply":{"width":512,"height":512,"paths":[{"d":"M8.3 189.8L184.3 37.9C199.7 24.5 224 35.3 224 56V136.1C384.6 137.9 512 170.1 512 322.3 512 383.8 472.4 444.6 428.7 476.5 415 486.4 395.6 473.9 400.6 457.8 445.9 312.8 379.1 274.3 224 272.1V360C224 380.7 199.7 391.5 184.3 378.2L8.3 226.2C-2.8 216.6-2.8 199.4 8.3 189.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/reply.js
// module id = bhVa
// module chunks = 0